import { render, staticRenderFns } from "./change-teams-password.vue?vue&type=template&id=0b3d79e8&scoped=true"
import script from "./change-teams-password.vue?vue&type=script&lang=js"
export * from "./change-teams-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d79e8",
  null
  
)

export default component.exports